(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /* AJAX pagination: clicking a page number swaps the product list without a full page reload */
  if (!window.__collectionAjaxPagination) {
    window.__collectionAjaxPagination = true;

    const swapResults = async (targetUrl, pushState) => {
      const current = document.querySelector('results-list');
      if (!current) {
        window.location.href = targetUrl;
        return;
      }

      current.style.opacity = '0.5';
      current.style.pointerEvents = 'none';
      current.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(targetUrl, { headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error(`Request failed: ${response.status}`);

        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incoming = doc.querySelector('results-list');
        if (!incoming) throw new Error('results-list not found');

        const next = document.importNode(incoming, true);
        current.replaceWith(next);

        if (pushState) {
          history.replaceState({ ajaxPagination: true }, '', window.location.href);
          history.pushState({ ajaxPagination: true }, '', targetUrl);
        }
        document.title = doc.title;

        const header = document.querySelector('header');
        const offset = (header ? header.offsetHeight : 0) + 16;
        window.scrollTo({ top: next.getBoundingClientRect().top + window.scrollY - offset, behavior: 'smooth' });
      } catch (error) {
        window.location.href = targetUrl;
      }
    };

    document.addEventListener(
      'click',
      (event) => {
        if (event.defaultPrevented || event.button !== 0) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        const link = event.target.closest('a[href]');
        if (!link || !link.closest('results-list')) return;

        const linkUrl = new URL(link.href, window.location.origin);
        const isPaginationLink =
          linkUrl.searchParams.has('page') || link.closest('[class*="pagination"], nav[aria-label*="agin" i]');

        if (linkUrl.origin !== window.location.origin || linkUrl.pathname !== window.location.pathname) return;
        if (!isPaginationLink) return;

        event.preventDefault();
        swapResults(linkUrl.href, true);
      },
      true
    );

    window.addEventListener('popstate', (event) => {
      if (event.state && event.state.ajaxPagination && document.querySelector('results-list')) {
        swapResults(window.location.href, false);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
